module.exports = __webpack_public_path__ + "media/icons/linkedin-circle-fd805912.svg";